import Demo from './pages';

function App() {
  return (
    <Demo />
  );
}

export default App;
